module.exports = __webpack_public_path__ + "assets/img/o1.d93f07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o1.jpg
// module id = pLUM
// module chunks = 1